module.exports = ".form-control {\n  border: 1px solid black;\n}\n.mat-form-field {\n  display: block;\n}\n.btn-invite {\n  border-radius: 50px;\n  background: #009FE8;\n  color: white;\n  outline: none;\n  font-weight: 700;\n}\n.modal-footer {\n    text-align: center !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/group/components/waiting-room/invite-friends-modal/invite-friends-modal.component.css
// module id = ./src/app/modules/group/components/waiting-room/invite-friends-modal/invite-friends-modal.component.css
// module chunks = main